// extracted by mini-css-extract-plugin
export var box = "_66-0";
export var check = "_66-1";
export var checkboxButton = "_66-6";
export var checkboxGroup = "_66-5";
export var disabled = "_66-7";
export var ghost = "_66-9";
export var input = "_66-2";
export var label = "_66-4";
export var normal = "_66-8";
export var uncheck = "_66-3";